import { call, getContext, put, select, fork, take } from 'redux-saga/effects';
import { RootAction } from 'store/state';
import { LoadOptions, LoadType } from 'store/sagas/apiService/types';
import { State as RouteState, Route } from 'config/routes';
import { queryData } from 'store/sagas/apiService';
import { navigateTo } from 'store/state/router/actions';
import { schoolPageAreaDocIdSelector, schoolAreaSearchVariablesSelector } from 'store/state/domainData/selectors/school';
import { searchDocEntriesSelector } from 'store/state/domainData/selectors/searchDoc';
import { makeSearchVariablesSelector } from 'store/state/app/selectors';
import { ISearchPoiVariables } from 'utils/entities';
import { flow, head } from 'lodash';
import { SET_DOMAIN_DATA } from 'store/state/domainData/types';


const projectListResolvePattern = (action: RootAction) => {
  if (action.type === SET_DOMAIN_DATA) {
    return (action.loadType === LoadType.SearchDoc) && Boolean(action.payload.data);
  }
  return false;
};

function* projectListWatcher() {
  yield take(projectListResolvePattern);

  const variables: ISearchPoiVariables = yield select(makeSearchVariablesSelector(flow(searchDocEntriesSelector, head)));

  const projectLoadOptions: LoadOptions<LoadType.SearchProjectList> = {
    loadType: LoadType.SearchProjectList,
    meta: { variables },
  };
  yield call(queryData, projectLoadOptions);
}

export function* schoolPageHandler(params: RouteState) {
  try {
    if (!params.params.id) {
      throw new Error('SchoolPageHandler: No school ID provided in params.');
    }
    yield fork(projectListWatcher);

    const loadOpts: LoadOptions<LoadType.SchoolByIdQuery> = {
      loadType: LoadType.SchoolByIdQuery,
      meta: {
        variables: {
          id: params.params.id,
        },
      },
    };

    yield call(queryData, loadOpts);

    const searchVariables = yield select(schoolAreaSearchVariablesSelector);
    const areaDocId = yield select(schoolPageAreaDocIdSelector);

    if (searchVariables) {
      yield call(queryData, {
        loadType: LoadType.SchoolSearch,
        meta: { variables: searchVariables },
      });
    }


    if (areaDocId) {
      yield call(queryData, {
        loadType: LoadType.SearchAwardsByDocIds,
        meta: { variables: { args: { docIds: [ areaDocId ], includeOnlyRelevantFeatures: true } } },
      });
    }
  }
  catch (e) {
    const logger = yield getContext('logger');
    logger.error('failed to load school data', e, navigateTo, put, Route);
    yield put(navigateTo(Route.Home, {}, { replace: true, ssrHttpStatus: 302 }));
  }
}
